<script lang="ts" setup>
	// @ts-ignore
	import { twMerge } from 'tailwind-merge'
	// @ts-ignore
	import { useScroll } from '@vueuse/core'

	defineOptions({inheritAttrs: false})

	const { offset = 250, icon = 'i-mdi-chevron-up', size = 'sm' } = defineProps<{
		offset?: number | string
		size?: 'sm' | 'md' | 'lg'
		icon?: string
	}>()

	const sizes = {
		sm: {button: 'size-10', icon: 'size-8'},
		md: {button: 'size-14', icon: 'size-12'},
		lg: {button: 'size-16', icon: 'size-14'}
	}

	const visible = ref<boolean>(false)
	const scollTop = () =>  {
		const { y }  =  useScroll(window, { behavior: 'smooth'})
		y.value = 0
	}

	onMounted(() => {
		useEventListener(window, 'scroll', function(){
			visible.value = window.scrollY > Number(offset)
		})
	})
</script>	const $attrs = useAttrs()

<template>
	<Transition
		enter-class="transition-all duration-300"
		enter-from-class="opacity-0 scale-75 translate-y-full"
		enter-to-class="opacity-100 scale-100 translate-y-0"
		leave-class="transition-all duration-200"
		leave-to-class="opacity-0 scale-0 translate-y-full"
	>
		<button
			v-show="visible"
			type="button"
			class="fixed cursor-pointer z-[100]"
			:class="twMerge('bottom-10 right-10 p-1 rounded-full bg-primary-950 hover:bg-accent text-white duration-300 shadow-md shadow-inverted '+ sizes[size].button, $attrs.class)"
			@click="scollTop"
		>
			<GsIcon :name="icon" :class="sizes[size].icon" />
		</button>
	</Transition>
</template>
